export const capitalizeFirstLetter = (word: string | undefined): string =>
  (!!word && word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()) || ''
